//商行管理 -- 商行管理（查看详情）
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import qs from 'qs';
import moment from 'moment';
import {
  Form,
  Button,
  Tabs,
  Row,
  Col,
  Icon,
  Dropdown,
  Menu,
  Modal,
  message,
  Spin,
  Checkbox,
  Table,
} from 'antd';

import PageHeaderLayout from '../../../component/page-header-layout/index';
import { hasPermissionCode } from '../../../utils/authority';
import {
  STALL_SYSTEM_TYPE,
  STALL_TYPES,
  STALL_SALE_TYPE,
  STALL_TYPE,
  BUSINESS_TYPE,
  CUSTOMER_TYPE,
  OPERATION_CYCLE,
  DELIVERY_STATUS,
  KOL_STATUS,
} from '../../../utils/deviceType';
import TestStall from '../../../common/images/icon/testStall.png';
import PreStall from '../../../common/images/icon/preStall.png';
import EditPng from '../../../common/images/icon/edit.png';
import './detail.less';

import {
  marketList,
  stallDetails,
  cleanStallDetail,
  getStallManger,
  restPassword,
  getAllStallEmploy,
  enableMarket,
  loginOutAll,
  solidifyStock,
  copyStall,
} from '../../../state/action/stall';

import Statistics from './stall/statistics';
import DeviceManagement from './stall/deviceManagement';
import ConfigManagement from './stall/configManagement';
import EmployeeManage from './stall/employeeManage';
import ContractManagement from './stall/contractManagement';
import ConvertType from './stall/convertType';
import ConvertSaleMode from './stall/convertSaleMode';
import UpdateStall from './stall/updateStall';
import TransferStall from './stall/transferStall';
import BasketSettings from './stall/basketSettings';
import AddtionFeeConfig from './stall/addtionFeeConfig';
import SettlementFee from './stall/settlementFee';
import SignatureAmount from './stall/SignatureAmount';
import ConfigList from './stall/configList';
import StallRoleManager from './stall/stallRoleManager';
import StallProductList from './stall/stallProductList';
import Serve from './stall/serve';
import CashierAccountConfiguration from './stall/cashierAccountConfiguration';
import BatchList from './stall/BatchList';

import ButtonUploadFile from './ButtonUploadFile/index';
import BuyerList from './stall/BuyerList/index';
import StallTemplateManage from './stall/stallTemplateManage';
import StallDotMatrixPrintTemplate from './stall/stallDotMatrixPrintTemplate';
import StallThermalPrinterTemplate from './stall/StallThermalPrinterTemplate';
import StallProductCorrection from '@/container/booth-stall-management/pages/stall/StallProductCorrection';
import { downStallRequest, getDownStallPactListRequest } from '../../../state/request/stall';

const { confirm } = Modal;
const { TabPane } = Tabs;

const STALL_DETAIL_DEFAULT_TAB = '1';
const mapText = (map, value) => (value || value === 0 ? map.get(value) || '- -' : '- -');
const normalizeKolValue = (value) => {
  if (value === true) {
    return 1;
  }
  if (value === false || value === undefined || value === null) {
    return 0;
  }
  return value;
};
const getStallKolValue = (stall = {}) => normalizeKolValue(stall.kol);

/** 不依赖权限的 Tab key（与下方 TabPane 一致） */
const STALL_DETAIL_ALWAYS_TAB_KEYS = new Set([
  '1',
  '7',
  '13',
  '2',
  '3',
  '6',
  '4',
  '5',
  '8',
  '9',
  '10',
  '16',
  '17',
  '18',
  '19',
  '20',
  '21',
]);

/**
 * Tab：优先取 URL search 中的 tab，无有效值时再取 location.state.tab
 * @param {string} [search]
 * @param {object} [locationState] 一般为 location.state
 * @returns {string|null}
 */
function parseStallDetailTabFromSearch(search, locationState) {
  if (search) {
    const parsed = qs.parse(search, { ignoreQueryPrefix: true });
    const tab = parsed.tab;
    if (typeof tab === 'string' && tab.length > 0) {
      return tab;
    }
  }
  const fromState = locationState && locationState.tab;
  if (typeof fromState === 'string' && fromState.length > 0) {
    return fromState;
  }
  return null;
}

function isStallDetailTabPermitted(key) {
  if (!key) return false;
  if (STALL_DETAIL_ALWAYS_TAB_KEYS.has(key)) return true;
  if (key === '11' && hasPermissionCode('01.056.002')) return true;
  if (
    key === '12' &&
    (hasPermissionCode('01.064.001') || process.env.REACT_APP_API === 'development')
  ) {
    return true;
  }
  if (key === '15' && hasPermissionCode('01.066.001')) return true;
  return false;
}

function normalizeStallDetailTabKey(key) {
  if (key && isStallDetailTabPermitted(key)) return key;
  return STALL_DETAIL_DEFAULT_TAB;
}

@connect(
  (state) => {
    return { stall: state.stall };
  },
  {
    marketList,
    stallDetails,
    cleanStallDetail,
    getStallManger,
    restPassword,
    getAllStallEmploy,
    enableMarket,
    loginOutAll,
    solidifyStock,
    copyStall,
  },
)
@Form.create()
class StallManagementDetail extends PureComponent {
  constructor(props) {
    super(props);
    this.stallId = this.props.location.state && this.props.location.state.stallId;
    this.from = this.props.location.state && this.props.location.state.from;
    const tabRaw = parseStallDetailTabFromSearch(
      this.props.location.search,
      this.props.location.state,
    );
    const initialTabKey = normalizeStallDetailTabKey(tabRaw || STALL_DETAIL_DEFAULT_TAB);
    this.state = {
      stallVisible: false, //修改档主
      transferVisible: false, //档主权限移交
      convertTypeVisible: false, //转换类型
      convertSaleModeVisible: false, //转换管理模式
      previewVisible: false,
      activeKey: initialTabKey,
      loading: true,
    };
  }

  componentDidMount() {
    this.mounted = true;
    this.props.cleanStallDetail();
    this.getMarketList(); //获得市场列表
    this.getStallDetail({ id: this.stallId }); // 查看商行详情
    this.syncStallDetailTabToUrl(this.state.activeKey);
  }

  componentWillUnmount() {
    this.mounted = false;
    this.props.cleanStallDetail();
  }

  componentDidUpdate(prevProps) {
    if (this.props.location.search !== prevProps.location.search) {
      const tabRaw = parseStallDetailTabFromSearch(
        this.props.location.search,
        this.props.location.state,
      );
      const nextKey = normalizeStallDetailTabKey(tabRaw || STALL_DETAIL_DEFAULT_TAB);
      if (nextKey !== this.state.activeKey) {
        this.setState({ activeKey: nextKey });
      }
    }
  }

  /** 将当前 Tab 写入路由 query（?tab=），便于刷新、复制链接、浏览器后退 */
  syncStallDetailTabToUrl = (tabKey) => {
    const key = normalizeStallDetailTabKey(tabKey);
    const { history, location } = this.props;
    const parsed = qs.parse(location.search, { ignoreQueryPrefix: true });
    if (parsed.tab === key) return;
    history.replace({
      pathname: location.pathname,
      state: { ...location.state },
      search: qs.stringify({ ...parsed, tab: key }, { addQueryPrefix: true }),
    });
  };

  //返回商行详情对象
  getStallDetailValue = () => {
    const {
      stall: { stallDetails },
    } = this.props;

    return stallDetails;
  };

  // 获得市场列表
  async getMarketList() {
    await this.props.marketList({});
  }

  // 查看商行详情
  async getStallDetail(params) {
    if (params.id == null) {
      this.setState({ loading: false });
      return;
    }
    const request = {};
    this.detailRequest = request;
    this.setState({ loading: true });
    try {
      await this.props.stallDetails(params);
    } catch (error) {
      // 请求层负责错误提示；仍需结束加载，避免页面一直转圈。
    } finally {
      if (this.mounted && this.detailRequest === request) {
        this.setState({ loading: false });
      }
    }
  }

  //刷新商行，在录入合同时，商行状态自动改为已签约
  refreshStall = () => {
    this.getStallDetail({ id: this.stallId }); // 查看商行详情
  };

  //按商行id加载详情
  reloadStallById = async (stallId) => {
    //按新id重新加载页面
    this.props.history.replace({
      pathname: '/booth/stallManager/stallManagementDetail',
      state: { stallId },
    });
    window.location.reload();
  };

  //返回
  back = (e) => {
    e.preventDefault();
    this.gotoBack();
  };

  gotoBack = () => {
    if (this.from === 'GO_BACK') {
      this.props.history.goBack();
    } else {
      this.props.history.push({ pathname: '/booth/stallManager/', state: {} });
    }
  };

  //编辑商行信息
  toEdit = () => {
    const {
      stall: { stallDetails },
    } = this.props;
    const record = stallDetails
      ? { ...stallDetails, kol: getStallKolValue(stallDetails) }
      : stallDetails;
    this.props.history.push({
      pathname: '/booth/stallManager/NewStallManage',
      state: { record, status: 'Detail' },
    });
  };

  //重置档主密码
  resetPwd(record) {
    const that = this;
    confirm({
      title: '是否重置档主密码为手机号后6位?',
      content: '',
      onOk() {
        const { personPhone } = record;
        that.restPassword({
          personPhone: personPhone,
        });
      },
      onCancel() {},
    });
  }
  //重置密码
  async restPassword(params) {
    const result = await this.props.restPassword(params);
    if (result.code === 200) {
      message.success('重置成功');
    } else {
      message.error(result.msg);
    }
  }

  //修改档主信息--获取档主信息
  async getStallManger(record) {
    const { id } = record; //personPhone
    await this.props.getStallManger({ id: id });
    this.setState({
      stallVisible: true,
    });
  }

  //关闭档主modal
  handleCancel = (result) => {
    if (result != null && result) {
      //关闭刷新
      const stall = this.getStallDetailValue();
      this.getStallDetail({ id: stall.id });
    }
    this.setState({ stallVisible: false });
  };

  //移交档主权限
  transferStall = (flag, result) => {
    const stall = this.getStallDetailValue();

    if (flag) {
      //弹开modal框
      //获取商行下所有员工信息
      this.getAllStallEmploy({ stallId: stall.id });
    }
    if (result != null && result) {
      //关闭刷新
      this.getStallDetail({ id: stall.id });
    }
    this.setState({
      transferVisible: flag,
    });
  };

  //获取商行下所有员工信息
  async getAllStallEmploy(params) {
    await this.props.getAllStallEmploy(params);
  }

  //转换商行版本
  handleCancelForConvertType = () => {
    this.setState({ convertTypeVisible: false });
  };
  // 转换管理模式
  handleCancelForConvertSaleMode = () => {
    this.setState({ convertSaleModeVisible: false });
  };

  //启用和注销商行
  enableMarket(record) {
    const that = this;
    confirm({
      title: <div>{record.enable ? '注销商行' : '启用商行'}</div>,
      content: (
        <div>
          {record.enable ? (
            <div>
              <div>注销商行后，商行用户将无法登录及使用</div>
              <div>确定要注销【{record.name}】吗？</div>
            </div>
          ) : (
            <div>
              <div>确定要启用【{record.name}】么？</div>
            </div>
          )}
        </div>
      ),
      async onOk() {
        const stall = that.getStallDetailValue();
        const { id } = stall;
        const result = await that.props.enableMarket({
          id,
          enable: !stall.enable,
        });
        if (result && result.code === 200) {
          message.success(stall.enable ? '注销成功' : '启用成功');
          await that.getStallDetail({ id });
          return;
        }
        Modal.error({
          title: stall.enable ? '注销商行失败' : '启用商行失败',
          content: (result && result.msg) || '操作失败，请稍后重试',
        });
      },
      onCancel() {},
    });
  }

  //注销登录
  loginOutAll(record) {
    const that = this;
    confirm({
      title: <div>注销登录</div>,
      content: (
        <div>
          <div>是否注销商行用户的登录状态</div>
        </div>
      ),
      async onOk() {
        const { id } = record;
        await that.props.loginOutAll({
          stallId: id,
        });
        await that.getStallDetail({ id });
      },
      onCancel() {},
    });
  }
  //固化库存
  solidifyStock(record) {
    const that = this;
    confirm({
      title: <div>固化库存</div>,
      content: (
        <div>
          <div>
            前置条件：
            <br />
            1.商行为按批次卖商行
            <br />
            2.商行配置【财务端进销存报表】
            <br />
            操作后固化该商行3个月前的库存数据
            <br />
          </div>
        </div>
      ),
      async onOk() {
        const { id } = record;
        const result = await that.props.solidifyStock(id);
        if (result.code === 200) {
          message.success('固化成功');
        }
      },
      onCancel() {},
    });
  }

  //复制商行
  copyStall = (record) => {
    const that = this;
    const { id } = record;

    const copyOptions = [
      { label: '买家', value: 'copyCustomer' },
      { label: '货主', value: 'copySupplier' },
      { label: '货品', value: 'copyProduct' },
      { label: '筐子', value: 'copyBasket' },
      { label: '员工', value: 'copyEmployee' },
    ];

    confirm({
      title: <div>复制商行</div>,
      width: '500px',
      content: (
        <div>
          <div>
            <div style={{ marginTop: '16px', marginBottom: '8px' }}>
              复制商行是否需要保留下方基础数据，如需保留请勾选
            </div>
            <Checkbox.Group
              options={copyOptions}
              defaultValue={['copyBasket']}
              onChange={(checkedValues) => {
                // 将选中的选项存储到 confirm 实例中，避免闭包问题
                confirm.selectedOptions = checkedValues;
              }}
            />
          </div>
          <div style={{ marginTop: '16px', marginBottom: '16px' }}>
            （若老商行为自动交账商行，复制的商行将不会自动交账，请更改配置或联系产研添加）
          </div>
        </div>
      ),
      async onOk() {
        const selectedOptions = confirm.selectedOptions || ['copyBasket'];

        // 构建复制选项参数
        const copyParams = {
          stallId: id,
          copyCustomer: selectedOptions.includes('copyCustomer'),
          copySupplier: selectedOptions.includes('copySupplier'),
          copyProduct: selectedOptions.includes('copyProduct'),
          copyBasket: selectedOptions.includes('copyBasket'),
          copyEmployee: selectedOptions.includes('copyEmployee'),
        };

        const { code, data } = await that.props.copyStall(copyParams);

        if (code === 200) {
          message.success('复制商行成功');
          await that.reloadStallById(data);
        }

        // 清理临时存储
        delete confirm.selectedOptions;
      },
      onCancel() {
        // 清理临时存储
        delete confirm.selectedOptions;
      },
    });
  };

  getStallStatus = () => {
    const {
      stall: { stallDetails = {} },
    } = this.props;
    const { loseTime, downTime } = stallDetails;
    let classname = 'status-normal';
    let text = '启用';
    if (loseTime) {
      classname = 'status-lose';
      text = '流失';
    } else if (downTime && !loseTime) {
      classname = 'status-stop';
      text = '停用';
    }
    return <span className={`status ${classname}`}>{text}</span>;
  };

  stopStall = async () => {
    const that = this;
    const {
      stall: { stallDetails = {} },
    } = this.props;
    const { loseTime, downTime } = stallDetails;
    let classname = 'status-normal';
    let text = '正常';
    if (loseTime) {
      classname = 'status-lose';
      text = '流失';
    } else if (downTime && !loseTime) {
      classname = 'status-stop';
      text = '停用';
    }
    if (classname === 'status-lose' || classname === 'status-stop') {
      message.error(`商行已${text}`);
      return;
    }
    const list = await getDownStallPactListRequest(that.stallId);
    if (list.code === 200) {
      confirm({
        title: '是否停用商行?',
        width: list.data.length > 0 ? '800px' : null,
        content:
          list.data.length > 0 ? (
            <div>
              <h4>停用商行会作废以下合同，请确认是否继续</h4>
              <Table
                dataSource={list.data}
                columns={[
                  {
                    title: '合同编号',
                    dataIndex: 'pactNo',
                  },
                  {
                    title: '合同生效日期',
                    dataIndex: 'startTime',
                    render: (text) => {
                      return text ? moment(text).format('YYYY-MM-DD') : '--';
                    },
                  },
                  {
                    title: '合同失效日期',
                    dataIndex: 'endTime',
                    render: (text) => {
                      return text ? moment(text).format('YYYY-MM-DD') : '--';
                    },
                  },
                ]}
              />
            </div>
          ) : null,
        async onOk() {
          const res = await downStallRequest(that.stallId);
          if (res.code === 200) {
            message.success('停用成功');
            that.refreshStall();
          }
        },
        onCancel() {},
      });
    }
  };

  render() {
    const { previewVisible, activeKey, loading } = this.state;
    const {
      stall: { stallDetails = {}, stallMangerInfoVo, marketData = [] },
    } = this.props;
    // Redux 可能仍有上一商行的数据，匹配当前 ID 后才挂载详情和各业务 Tab。
    if (
      !stallDetails ||
      stallDetails.id == null ||
      String(stallDetails.id) !== String(this.stallId)
    ) {
      return (
        <PageHeaderLayout>
          <a href='/' onClick={this.back}>
            返回
          </a>
          <Spin spinning={loading}>
            <div style={{ padding: 24 }}>
              {loading ? '正在加载商行详情…' : '未获取到当前商行详情，请返回重试'}
            </div>
          </Spin>
        </PageHeaderLayout>
      );
    }
    const layout = { xs: 24, sm: 12, md: 12, lg: 12, xl: 12 };
    const layout1 = { xs: 24, sm: 12, md: 12, lg: 8, xl: 8 };
    const { loseTime, downTime } = stallDetails;
    const resetPassword = (
      <a
        href='/'
        onClick={(e) => {
          e.preventDefault();
          this.resetPwd(stallDetails);
        }}
        style={{ textAlign: 'center' }}
      >
        重置密码
      </a>
    );
    const updateStall = (
      <a
        href='/'
        onClick={(e) => {
          e.preventDefault();
          this.getStallManger(stallDetails);
        }}
        style={{ textAlign: 'center' }}
      >
        修改档主
      </a>
    );
    const transferStall = (
      <a
        href='/'
        onClick={(e) => {
          e.preventDefault();
          this.transferStall(true);
        }}
        style={{ textAlign: 'center' }}
      >
        移交档主权限
      </a>
    );
    const convertType = (
      <a
        href='/'
        onClick={(e) => {
          e.preventDefault();
          this.setState({ convertTypeVisible: !this.state.convertTypeVisible });
        }}
        style={{ textAlign: 'center' }}
      >
        转换商行版本
      </a>
    );
    const convertSaleMode = (
      <a
        href='/'
        onClick={(e) => {
          e.preventDefault();
          this.setState({ convertSaleModeVisible: !this.state.convertSaleModeVisible });
        }}
        style={{ textAlign: 'center' }}
      >
        转换管理模式
      </a>
    );
    const loginOutAll = (
      <a
        href='/'
        onClick={(e) => {
          e.preventDefault();
          this.loginOutAll(stallDetails);
        }}
        style={{ textAlign: 'center' }}
      >
        注销登录
      </a>
    );
    const solidifyStock = (
      <a
        href='/'
        onClick={(e) => {
          e.preventDefault();
          this.solidifyStock(stallDetails);
        }}
        style={{ textAlign: 'center' }}
      >
        固化库存
      </a>
    );
    const stallCopy = (
      <a
        href='/'
        onClick={(e) => {
          e.preventDefault();
          this.copyStall(stallDetails);
        }}
        style={{ textAlign: 'center' }}
      >
        复制商行
      </a>
    );

    const styleValue = stallDetails.enable
      ? { textAlign: 'center', color: '#FF0000' }
      : { textAlign: 'center' };
    const enableMarket = (
      <a
        href='/'
        onClick={(e) => {
          e.preventDefault();
          this.enableMarket(stallDetails);
        }}
        style={styleValue}
      >
        {stallDetails.enable ? '注销商行' : '启用注销商行'}
      </a>
    );
    // 点击更多的菜单
    const menu = (
      <Menu>
        <Menu.Item>{resetPassword}</Menu.Item>
        <Menu.Item>{updateStall}</Menu.Item>
        <Menu.Item>{transferStall}</Menu.Item>
        {hasPermissionCode('01.003.006') ? <Menu.Item>{convertType}</Menu.Item> : null}
        <Menu.Item>{convertSaleMode}</Menu.Item>
        <Menu.Item>{loginOutAll}</Menu.Item>
        <Menu.Item>{solidifyStock}</Menu.Item>
        <Menu.Item>{stallCopy}</Menu.Item>
        {hasPermissionCode('01.003.004') ? <Menu.Item>{enableMarket}</Menu.Item> : null}
        {!downTime && !loseTime ? (
          <Menu.Item>
            <a
              href='/'
              onClick={(e) => {
                e.preventDefault();
                this.stopStall();
              }}
              style={{ textAlign: 'center', color: '#FF0000' }}
            >
              停用商行
            </a>
          </Menu.Item>
        ) : null}
      </Menu>
    );

    if (stallDetails) {
      if (stallDetails.type === 3) {
        stallDetails.type = 1;
      } else if (stallDetails.type === 4) {
        stallDetails.type = 2;
      }
    }

    return (
      <PageHeaderLayout>
        <Spin spinning={loading}>
          <div className='StallManagementDetail'>
            <Row className='backRow'>
              <a href='/' onClick={this.back}>
                <Icon type='left' /> 返回
              </a>
            </Row>
            <Row className='row1'>
              <Col {...{ xs: 24, sm: 24, md: 24, lg: 17, xl: 17 }}>
                <Row>
                  <Col span={24} className='title'>
                    商行业务ID：{stallDetails.businessCode || '- -'}({stallDetails.id})
                    <span
                      className={`enable ${stallDetails.enable ? 'enable-true' : 'enable-false'}`}
                    >
                      {stallDetails.enable ? '未注销' : '已注销'}
                    </span>
                    {this.getStallStatus()}
                  </Col>
                </Row>
                <Row>
                  <Col span={24} className='title'>
                    商行名称：{stallDetails.name || '- -'}
                    <span className='color1'>（{stallDetails.shortName || '- -'}）</span>
                    <a
                      href='/'
                      onClick={(e) => {
                        e.preventDefault();
                        this.toEdit();
                      }}
                    >
                      <img src={EditPng} alt='' style={{ width: 28 }} />
                    </a>
                  </Col>
                </Row>
                <Row>
                  <Col {...layout1} className='colLabel'>
                    商行版本：
                    <span className='color2'>{STALL_TYPE.get(stallDetails.type) || '- -'}</span>
                  </Col>
                  <Col {...layout1} className='colLabel'>
                    管理模式：
                    <span className='color2'>
                      {stallDetails.saleType ? STALL_SALE_TYPE.get(stallDetails.saleType) : '- -'}
                    </span>
                  </Col>
                  <Col {...layout1} className='colLabel'>
                    有效期至：
                    <span className='color2'>
                      {stallDetails.serviceEndTime > 0
                        ? moment(stallDetails.serviceEndTime).format('YYYY-MM-DD')
                        : null}
                    </span>
                  </Col>
                </Row>
                <Row>
                  <Col {...layout1} className='colLabel'>
                    联系人：
                    <span className='color2'>{stallDetails.personName}</span>
                  </Col>
                  <Col {...layout1} className='colLabel'>
                    归属地：
                    <span className='color2'>{`${stallDetails.provinceName || ''} ${
                      stallDetails.cityName || ''
                    } ${stallDetails.areaName || ''}`}</span>
                  </Col>
                  <Col {...layout1} className='colLabel'>
                    所属市场：
                    <span className='color2'>{stallDetails.marketName || '- -'}</span>
                  </Col>
                </Row>
                <Row>
                  <Col {...layout1} className='colLabel'>
                    联系电话：<span className='color2'>{stallDetails.phone || '- -'}</span>
                  </Col>
                  <Col {...layout1} className='colLabel'>
                    创建时间：
                    <span className='color2'>
                      {stallDetails.createTime
                        ? moment(stallDetails.createTime).format('YYYY-MM-DD HH:mm')
                        : '- -'}
                    </span>
                  </Col>
                  <Col {...layout1} className='colLabel'>
                    签约时间：
                    <span className='color2'>
                      {stallDetails.pactStartTime
                        ? moment(stallDetails.pactStartTime).format('YYYY-MM-DD HH:mm')
                        : '- -'}
                    </span>
                  </Col>
                </Row>
                <Row>
                  <Col {...layout1} className='colLabel'>
                    商行分类：
                    <span className='color2'>
                      {STALL_TYPES.get(stallDetails.pactStatus) || '- -'}
                    </span>
                  </Col>
                  <Col {...layout1} className='colLabel'>
                    系统类型：
                    <span className='color2'>
                      {stallDetails.systemType
                        ? STALL_SYSTEM_TYPE.get(stallDetails.systemType)
                        : '- -'}
                    </span>
                  </Col>
                  <Col {...layout1} className='colLabel'>
                    营业时间：
                    <span className='color2'>{stallDetails.businessHours}</span>
                  </Col>
                  <Col {...layout1} className='colLabel'>
                    经营品类：
                    <span className='color2'>
                      {BUSINESS_TYPE[stallDetails.businessType] || '蔬菜'}
                    </span>
                  </Col>
                  <Col {...layout1} className='colLabel'>
                    客户类型：
                    <span className='color2'>
                      {mapText(CUSTOMER_TYPE, stallDetails.customerType)}
                    </span>
                  </Col>
                  <Col {...layout1} className='colLabel'>
                    经营周期：
                    <span className='color2'>
                      {mapText(OPERATION_CYCLE, stallDetails.businessCycle)}
                    </span>
                  </Col>
                  <Col {...layout1} className='colLabel'>
                    交付状态：
                    <span className='color2'>
                      {mapText(DELIVERY_STATUS, stallDetails.deliveryStatus)}
                    </span>
                  </Col>
                  <Col {...layout1} className='colLabel'>
                    是否为KOL：
                    <span className='color2'>
                      {mapText(KOL_STATUS, getStallKolValue(stallDetails))}
                    </span>
                  </Col>
                  <Col {...layout1} className='colLabel'>
                    集团名称：
                    <span className='color2'>{stallDetails.orgName}</span>
                  </Col>
                  {stallDetails.businessLicense && (
                    <Col {...layout1} className='colLabel'>
                      营业执照：
                      <span
                        className='color2'
                        style={{ textDecoration: 'underline', cursor: 'pointer', color: 'green' }}
                        onClick={() => {
                          this.setState({
                            previewVisible: true,
                          });
                        }}
                      >
                        点击查看
                      </span>
                    </Col>
                  )}
                </Row>
                <Row>
                  <Col className='colLabel'>
                    商行地址：
                    <span className='color2'>{stallDetails.address || '- -'}</span>
                  </Col>
                </Row>
                <Row>
                  <Col {...layout1} className='colLabel'>
                    停用日期：
                    <span className='color2'>
                      {stallDetails?.downTime
                        ? moment(stallDetails?.downTime).format('YYYY-MM-DD')
                        : '- -'}
                    </span>
                  </Col>
                  <Col {...layout1} className='colLabel'>
                    流失生效日期：
                    <span className='color2'>
                      {stallDetails?.loseTime
                        ? moment(stallDetails?.loseTime).format('YYYY-MM-DD HH:mm:ss')
                        : '- -'}
                    </span>
                  </Col>
                </Row>
                <Row>
                  <Col className='colLabel'>
                    单据显示市场：
                    {stallDetails.definedMarketName || '- -'}
                  </Col>
                </Row>
                <Row>
                  <Col className='colLabel'>
                    备注：
                    <span className='color2'>{stallDetails.stallRemark || '- -'}</span>
                  </Col>
                </Row>
                <br />
              </Col>
              <Col
                {...{ xs: 24, sm: 24, md: 24, lg: 7, xl: 7 }}
                style={{ display: 'flex', justifyContent: 'space-between' }}
              >
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  <ButtonUploadFile
                    stallId={this.stallId}
                    businessCode={stallDetails.businessCode}
                  />
                  <Dropdown overlay={menu} trigger={['click']}>
                    <Button type='primary' style={{ background: '#01b755', width: 116 }}>
                      更多 <Icon type='down' />
                    </Button>
                  </Dropdown>
                </div>
                {stallDetails.type === 1 || stallDetails.type === 2 ? (
                  <img src={PreStall} alt='' style={{ width: 150 }} />
                ) : stallDetails.type === 3 || stallDetails.type === 4 ? (
                  <img src={TestStall} alt='' style={{ width: 150 }} />
                ) : null}
              </Col>
            </Row>
            <br />
            <Row className='row2'>
              <Tabs
                activeKey={activeKey}
                onChange={(key) => {
                  this.setState({ activeKey: key });
                  this.syncStallDetailTabToUrl(key);
                }}
              >
                <TabPane tab='数据统计' key='1'>
                  <Statistics stallId={this.stallId} />
                </TabPane>
                <TabPane tab='配置功能管理' key='7'>
                  <ConfigManagement
                    stallId={this.stallId}
                    marketId={stallDetails.marketId}
                    businessCode={stallDetails.businessCode}
                  />
                </TabPane>
                <TabPane tab='增值服务管理' key='13'>
                  <Serve stallId={this.stallId} marketId={stallDetails.marketId} />
                </TabPane>
                <TabPane tab='设备管理' key='2'>
                  <DeviceManagement
                    stallId={this.stallId}
                    marketId={stallDetails.marketId}
                    businessCode={stallDetails.businessCode}
                    stallName={stallDetails.name}
                  />
                </TabPane>
                <TabPane tab='合同管理' key='3'>
                  <ContractManagement
                    stallId={this.stallId}
                    signSaleId={stallDetails.signSaleId || undefined}
                    stallType={stallDetails.pactStatus}
                    sign
                    marketId={stallDetails.marketId}
                    refreshStall={this.refreshStall}
                  />
                </TabPane>
                <TabPane tab='附加费用配置' key='6'>
                  <AddtionFeeConfig stallId={this.stallId} marketId={stallDetails.marketId} />
                </TabPane>
                <TabPane tab='筐子设置' key='4'>
                  {activeKey === '4' && (
                    <BasketSettings stallId={this.stallId} marketId={stallDetails.marketId} />
                  )}
                </TabPane>
                <TabPane tab='结算费用设置' key='5'>
                  <SettlementFee stallId={this.stallId} marketId={stallDetails.marketId} />
                </TabPane>
                <TabPane tab='商行员工管理' key='8'>
                  <EmployeeManage stallId={this.stallId} marketId={stallDetails.marketId} />
                </TabPane>
                <TabPane tab='支付柜台配置' key='9'>
                  <ConfigList stallId={this.stallId} marketId={stallDetails.marketId} />
                </TabPane>
                <TabPane tab='角色配置' key='10'>
                  <StallRoleManager stallId={this.stallId} marketId={stallDetails.marketId} />
                </TabPane>
                {hasPermissionCode('01.056.002') && (
                  <TabPane tab='签字额度' key='11'>
                    <SignatureAmount stallId={this.stallId} marketId={stallDetails.marketId} />
                  </TabPane>
                )}
                {(hasPermissionCode('01.064.001') ||
                  process.env.REACT_APP_API === 'development') && (
                  <TabPane tab='货品列表' key='12'>
                    <StallProductList stallId={this.stallId} saleType={stallDetails.saleType} />
                  </TabPane>
                )}
                <TabPane tab='批次列表' key='19'>
                  {activeKey === '19' && <BatchList stallId={this.stallId} />}
                </TabPane>
                <TabPane tab='商行买家' key='16'>
                  {activeKey === '16' && (
                    <BuyerList stallId={this.stallId} marketId={stallDetails.marketId} />
                  )}
                </TabPane>
                {hasPermissionCode('01.066.001') && (
                  <TabPane tab='收银账户配置' key='15'>
                    <CashierAccountConfiguration
                      stallId={this.stallId}
                      marketId={stallDetails.marketId}
                    />
                  </TabPane>
                )}
                <TabPane tab='标签模板配置' key='17'>
                  <StallTemplateManage stallId={this.stallId} marketId={stallDetails.marketId} />
                </TabPane>
                <TabPane tab='针式打印模板配置' key='18'>
                  <StallDotMatrixPrintTemplate
                    stallId={this.stallId}
                    marketId={stallDetails.marketId}
                    history={this.props.history}
                  />
                </TabPane>
                <TabPane tab='小票打印模板配置' key='20'>
                  <StallThermalPrinterTemplate
                    stallId={this.stallId}
                    marketId={stallDetails.marketId}
                    history={this.props.history}
                  />
                </TabPane>
                <TabPane tab='货品纠正' key='21'>
                  {activeKey === '21' && <StallProductCorrection stallId={this.stallId} />}
                </TabPane>
              </Tabs>
            </Row>

            {/**修改档主信息 */}
            <UpdateStall
              stallVisible={this.state.stallVisible}
              stallMangerInfoVo={stallMangerInfoVo}
              handleCancel={this.handleCancel}
            />
            {/**移交档主权限 */}
            <TransferStall
              transferVisible={this.state.transferVisible}
              record={stallDetails}
              handleCancelForTransfer={this.transferStall}
            />
            {/**转换系统类型 */}
            <ConvertType
              id={this.stallId}
              type={stallDetails.type}
              convertTypeVisible={this.state.convertTypeVisible}
              handleCancelForConvertType={this.handleCancelForConvertType}
              handleDetail={() => this.getStallDetail({ id: this.stallId })}
              marketData={marketData}
              stallDetails={stallDetails}
            />
            {/**转换商行版本 */}
            <ConvertSaleMode
              id={this.stallId}
              saleType={stallDetails.saleType}
              convertSaleModeVisible={this.state.convertSaleModeVisible}
              handleCancelForConvertSaleMode={this.handleCancelForConvertSaleMode}
              handleDetail={() => this.getStallDetail({ id: this.stallId })}
              stallDetails={stallDetails}
              marketData={marketData}
            />
          </div>
          {stallDetails.businessLicense && (
            <Modal
              width={800}
              className='picModal'
              visible={previewVisible}
              footer={null}
              onCancel={() => {
                this.setState({
                  previewVisible: false,
                });
              }}
            >
              <img alt='' style={{ width: '100%' }} src={stallDetails.businessLicense} />
            </Modal>
          )}
        </Spin>
      </PageHeaderLayout>
    );
  }
}
// 同一路由切换商行时重建详情及其子组件；切换 Tab 时保留当前实例。
export default function StallManagementDetailRoute(props) {
  const stallId = props.location.state && props.location.state.stallId;
  return <StallManagementDetail key={stallId} {...props} />;
}
